
var Model = require("../types/Model.js");
var CACHE_KEY = "_cache_personal";
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
/**
 * Keeps track of the state of the current user's data/preferences
 * @type {Model}
 */
module.exports = Model({
	name: "personal",
	init: init,
	listeners: listeners,
	triggers: triggers,
	refresh_data: refresh_data,
	clearCache: clearCache
});

/**
 * Sets up listeners for changes in data, does initial refresh
 * @return {Promise} Resolves to initial state
 */
function init() {
	this.emit("logout:trigger:setup", {
		type: "personal"
	});
	this.emit("refresh:trigger:setup", {
		type: "personal"
	});
	this.refresh_data();
}

function listeners() {
	return {
		"mqtt:$/settings": handle_settings_change,
		"connectivity:online": refresh_data
	};
}

function triggers(){
	return {
		"clear": clearCache,
		"refresh": handleRefresh,
		"logout": handleLogout
	};
}

function handleRefresh(){
	this.clearCache().then(() => {
		this.emit("refresh:trigger:finish", {
			type: "personal"
		});
	});
}

function handleLogout(){
	this.clearCache().then(() => {
		this.emit("logout:trigger:finish", {
			type: "personal"
		});
	});
}

function clearCache(){
	return AsyncStorage.removeItem(CACHE_KEY)
		.catch(e => console.error(e));
}

function handle_settings_change(data) {
	this.extend(data);
}

/**
 * Gets the latest state of the data from the server, pushes it down
 * @return {Promise} Resolves to the latest data
 */
function refresh_data() {
	return this.api.people.data().then(this.push.bind(this));
}